/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import styles from './styles.scss';

export const ComponentGrouper = (props) => {
  const hasMany = props.children.length > 1 || props.children.size > 1; // handles immutable
  const styleClass =
    hasMany || props.singletonGroup
      ? styles.componentGroupingMany
      : styles.componentGrouping;

  let attributesComponent;

  // if the group has a title,
  // either show the component provided or if editable, show an input field
  if (props.hasTitle) {
    if (props.attributesComponent) {
      attributesComponent = props.attributesComponent;
    } else if (
      props.titleEditable &&
      props.hasTitle &&
      (hasMany || props.singletonGroup)
    ) {
      attributesComponent = (
        <div className="row">
          <div className="col-md-3">
            <FormControl
              type="text"
              className="componentGroupingTitle"
              data-testid="componentGroupingTitle"
              value={props.titleValue}
              placeholder="Group Name"
              onChange={(e) => props.onChange('group_title', e.target.value)}
            />
          </div>
        </div>
      );
    }
  }

  return (
    <div
      className={styleClass}
      data-test="component-grouping"
      data-testid="componentGrouping"
    >
      {attributesComponent}
      {props.children}
    </div>
  );
};

ComponentGrouper.propTypes = {
  children: PropTypes.any,
  hasTitle: PropTypes.bool,
  titleEditable: PropTypes.bool,
  titleValue: PropTypes.string,
  onChange: PropTypes.func,
};

ComponentGrouper.defaultProps = {
  titleEditable: false,
};
